// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb{margin-top:2rem;margin-bottom:8rem}.breadcrumb+.section .container .stagecontent{margin-top:3rem}@media (min-width:768px){.breadcrumb+.section .container .stagecontent{margin-top:-5rem}}.breadcrumb__item:not(:last-child):after{content:\"|\";font-size:.8em;display:inline-block;padding-left:.3rem;padding-right:.3rem}.breadcrumb__item:last-child .breadcrumb__link{pointer-events:none;--tw-text-opacity:1;color:rgba(0,0,0,var(--tw-text-opacity))}", ""]);
// Exports
module.exports = exports;
